export const REJECTION_REASON_MAX_LENGTH = 2000;
